import React, { useEffect } from 'react';
import { change as changeAction } from 'redux-form';
import { useSelector, useDispatch } from 'react-redux';
import { FieldForm } from '@app/src/common/FieldForm';
import { Select } from '@app/src/common/Select';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';
import { fetchTypeOperationAction, TypeOperationModel } from '@app/src/views/StepOne/form';

interface Props {
  activeColor?: string;
}

export const TypeOperation: React.FC<Props> = ({
  activeColor
}) => {
  const dispatch = useDispatch();
  const operations: SelectItemModel[] = useSelector(state => state.typeOperation.data);
  const isFetching: boolean = useSelector(state => state.typeOperation.isFetching);
  const currentOperation: number = useSelector(state => state.form.stepOne.values.operation);
  const currentCategory: number = useSelector(state => state.print.general.category);
  const printOperation: number = useSelector(state => state.print.general.operation);
  const printOperationName: number = useSelector(state => state.print.general.operationName);
  
  useEffect(() => {
    if (currentCategory) {
      dispatch(fetchTypeOperationAction(currentCategory));
      dispatch(changeAction('stepOne', 'category', currentCategory));
    }
  }, [currentCategory]);

  useEffect(() => {
    if (operations && operations.length > 0) {
      if (printOperation) {
        dispatch(changeAction('stepOne', 'operation', printOperation));
        dispatch(changeAction('stepOne', 'operationName', printOperationName));
      }
    }
  }, [operations]);

  const handleChange = (operation: TypeOperationModel) => {
    dispatch(changeAction('stepOne', 'operation', operation.id));
    dispatch(changeAction('stepOne', 'operationName', operation.name));
  };

  return(
    <React.Fragment>
      <FieldForm label="Tipo de operación">
        <Select
          dataList={operations}
          handleChange={handleChange}
          placeholder="Seleccione un tipo de operación"
          modalTitle="Tipo de operación"
          optionColor={activeColor}
          isLoading={isFetching}
          initialIndex={currentOperation}
        />
      </FieldForm>
    </React.Fragment>
  )
};
